import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import './App.css';

// Context Providers
import { ProductProvider } from './components/ProductContext';
import Search from "./components/Search";

// Protected Routes
import ProtectedRoute from './components/ProtectedRoute';
import CustomerProtectedRoute from './components/CustomerProtectedRoute';

// Components & Pages
import AdminProducts from './components/AdminProducts';
import AdminCategory from './components/AdminCategory';
import Home from './pages/Home';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogSingle from './pages/BlogSingle';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import ProductSingle from './pages/ProductSingle';
import Shop from './pages/Shop';
import Wishlist from './pages/Wishlist';
import Registration from './pages/Registration';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import AdminReg from './pages/AdminReg';
import MyOrders from './pages/MyOrders';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DataDeletionPolicy from './pages/DataDeletionPolicy';
import RefundAndCancellationPolicy from './pages/RefundAndCancellationPolicy';
import ReturnPolicy from './pages/ReturnPolicy';
import ShippingPolicy from './pages/ShippingPolicy';
import DealOfTheDayAdmin from './components/DealOfTheDay';
import AdminOrder from './components/AdminOrder';
import MyAccount from './components/MyAccount';
import Settings from './components/Setting';
import Testimonials from './components/TestimonialsAdmin';
import Razorpay from 'razorpay';
// Toast
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App: React.FC = () => {
  // ✅ Base URL for all axios requests
  axios.defaults.baseURL = 'https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net';

  return (
    <ProductProvider>
        <Router>
          {/* Toast Notifications */}
          <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

          {/* Routes */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog-single" element={<BlogSingle />} />
            <Route path="/blog/:id" element={<BlogSingle />} />
            <Route path="/cart" element={<CustomerProtectedRoute element={<Cart />} />} />
            <Route path="/checkout" element={<CustomerProtectedRoute element={<Checkout />} />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/product-single/:productId" element={<ProductSingle />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/wishlist" element={<CustomerProtectedRoute element={<Wishlist />} />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/registration" element={<AdminReg />} />
            <Route path="/my-orders" element={<CustomerProtectedRoute element={<MyOrders />} />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/data-deletion-policy" element={<DataDeletionPolicy />} />
            <Route path="/refund-and-cancellation-policy" element={<RefundAndCancellationPolicy />} />
            <Route path="/return-policy" element={<ReturnPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/admin" element={<ProtectedRoute element={<AdminProducts />} />} />
            <Route path="/admin/categories" element={<ProtectedRoute element={<AdminCategory />} />} />
            <Route path="/admin/deal-of-the-day" element={<ProtectedRoute element={<DealOfTheDayAdmin />} />} />
            <Route path="/admin/orders" element={<ProtectedRoute element={<AdminOrder />} />} />
            <Route path="/my-account" element={<CustomerProtectedRoute element={<MyAccount />} />} />
            <Route path="/my-setting" element={<CustomerProtectedRoute element={<Settings />} />} />
            <Route path="/testimonialsadmin" element={<Testimonials />} />
          </Routes>
        </Router>
    </ProductProvider>
  );
};

export default App;

